import React from "react";
import { Link, useHistory } from "react-router-dom";
import { t } from "i18next";

function LogOutBtn() {
  const history = useHistory();

  async function logOut() {
    localStorage.removeItem("token");
    window.location.reload();
    history.push("/login");
  }

  return (
    <Link
      onClick={logOut}
      to="/login"
      className="mx-3 my-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
    >
      Abmelden
    </Link>
  );
}

export default LogOutBtn;
